import { CircularProgress, Hidden } from "@material-ui/core";
import React, { useEffect } from "react";
import usePendingRequest from "../../hooks/usePendingRequest";
import { useTranslation } from "../../hooks/useTranslation";
import Dialog from "../common/Dialog";
import { Title } from "../common/Title";
import PendingRequestData from "./PendingRequestData/PendingRequestData";
import PendingRequestDataMobile from "./PendingRequestDataMobile/PendingRequestDataMobile";
import PendingRequestSearch from "./PendingRequestSearch/PendingRequestSearch";
import { useStyles } from "./PendingRequestsStyles";

const PendingRequests = () => {
  const { pendingRequestStore, onAccept, onReject, handleClose } =
    usePendingRequest();
  const classes = useStyles();
  const { refreshDataTable } = usePendingRequest();
  const { t, BundleKey } = useTranslation();

  useEffect(() => {
    if (pendingRequestStore.listPendingRequest) refreshDataTable();
  }, [pendingRequestStore.listPendingRequest]);

  return (
    <div className={classes.root}>
      <Title>{t(BundleKey.PENDINGREQUEST_TITLE)}</Title>
      {pendingRequestStore.loading ? (
        <CircularProgress />
      ) : (
        <div className={classes.grid}>
          <PendingRequestSearch />
          <Hidden smDown>
            <PendingRequestData />
          </Hidden>
          <Hidden mdUp>
            <PendingRequestDataMobile />
          </Hidden>
        </div>
      )}
      <Dialog
        open={pendingRequestStore.onAccept}
        onSubmit={onAccept}
        onClose={handleClose}
        labelNo={t(BundleKey.ACTION_CANCEL)}
        labelYes={t(BundleKey.ACTION_ACCEPT)}
        bold
      >
        {t(BundleKey.PENDINGREQUEST_ACTION_DIALOG_MESSAGE_CONFIRM)}
      </Dialog>
      <Dialog
        open={pendingRequestStore.onReject}
        onSubmit={onReject}
        onClose={handleClose}
        labelNo={t(BundleKey.ACTION_CANCEL)}
        labelYes={t(BundleKey.ACTION_ACCEPT)}
        bold
      >
        {t(BundleKey.PENDINGREQUEST_ACTION_DIALOG_MESSAGE_REJECT)}
      </Dialog>
    </div>
  );
};

export default PendingRequests;
